// https://github.com/orestbida/cookieconsent
// https://github.com/orestbida/cookieconsent/tree/v2.9
import 'vanilla-cookieconsent';
import prestashop from 'prestashop';
import { cookies } from './categories';
import { clearCategories } from './cleanup';
import { makeConfig } from './config';
import { bindConsentMode } from './consent-mode';

const cc = initCookieConsent();

const updateConsent = () => {
    const { accepted_categories, rejected_categories } =
        cc.getUserPreferences();

    accepted_categories.forEach((category) => {
        prestashop.emit('gdprUpdate', { key: category, value: true });
    });

    rejected_categories.forEach((category) => {
        prestashop.emit('gdprUpdate', { key: category, value: false });
    });

    window.dispatchEvent(
        new CustomEvent('CookieConsent:updateConsent', {
            detail: { cookieConsent: cc },
        }),
    );
};

// Scripts of withdrawn categories are still running on the page and could
// write their cookies again: clear, then reload once Consent Mode is updated
const withdrawConsent = (withdrawnCategories: string[]) => {
    if (!withdrawnCategories.length) {
        return;
    }

    clearCategories(withdrawnCategories);
    window.location.reload();
};

const initCookieConsentManager = () => {
    bindConsentMode();

    cc.run(
        makeConfig({
            onConsent: updateConsent,
            // Trackers dropped before any choice (e.g. revision bump) are removed
            // if refused: no script of these categories was loaded, no reload
            onFirstChoice: clearCategories,
            onWithdraw: withdrawConsent,
        }),
    );

    // No consent given yet: push the default state
    if (!cc.validConsent()) {
        prestashop.emit('gdprInit', cookies);
    }

    window.addEventListener('open-cookieconsent', () => {
        cc.showSettings(0);
    });

    return cc;
};

// Reads the consent cookie: usable before or after cc.run()
const isCategoryAllowed = (category: string) => cc.allowedCategory(category);

export { initCookieConsentManager as CookieConsent, isCategoryAllowed };
